import { render, staticRenderFns } from "./admissionFormApprovers.vue?vue&type=template&id=3d79d01c"
import script from "./admissionFormApprovers.vue?vue&type=script&lang=js"
export * from "./admissionFormApprovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports